import {
	DepositOwner,
	MoneySource,
	OccupationType,
	PurposeOfDeposit,
	PurposeOfLoan,
	AccommodationType,
	MaritalStatus,
	Education,
	EmploymentSector,
} from './kycTypes'

export const kycCurrenciesAndValues: IKycCurrencyAndValues[] = [
	{
		currency: 'DKK',
		country: 'dk',
		income: [200000, 450000, 700000, 1000000, 1000001], // These numerical values are probably wrong, but no matter just now.
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [10000, 50000, 200000, 450000, 450001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [10000, 50000, 200000, 450000, 450001],
		purposeOfLoan: [
			PurposeOfLoan.Consumption,
			PurposeOfLoan.DebtConsolidation,
			PurposeOfLoan.Renovation,
			PurposeOfLoan.HomeExpenses,
			PurposeOfLoan.Healthcare,
			PurposeOfLoan.Travel,
			PurposeOfLoan.PurchaseVehicle,
			PurposeOfLoan.Donation,
			PurposeOfLoan.RealEstatePurchase,
			PurposeOfLoan.Other,
		],
	},
	{
		currency: '€',
		country: 'fi',
		income: [20000, 45000, 70000, 100000, 100001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.PartTime,
			OccupationType.Entrepreneur,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.Student,
			OccupationType.TemporarilyEmployed,
			OccupationType.Other,
		],
		moneySource: [
			MoneySource.Income,
			MoneySource.Savings,
			MoneySource.Investments,
			MoneySource.Inheritance,
			MoneySource.Gift,
			MoneySource.SalesOfProperty,
			MoneySource.SalesOfVehicle,
			MoneySource.SalesOfCulture,
			MoneySource.SaleOfCompany,
			MoneySource.Gambling,
			MoneySource.OtherBusiness,
			MoneySource.CapitalGains,
			MoneySource.InsuranceReimbursement,
			MoneySource.SocialInsuranceAllowance,
			MoneySource.Other,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.PersonalEconomicSpace,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.Retirement,
			PurposeOfDeposit.Other,
		],
		purposeOfLoan: [
			PurposeOfLoan.Consumption,
			PurposeOfLoan.DebtConsolidation,
			PurposeOfLoan.Renovation,
			PurposeOfLoan.HomeExpenses,
			PurposeOfLoan.Healthcare,
			PurposeOfLoan.Travel,
			PurposeOfLoan.PurchaseVehicle,
			PurposeOfLoan.Gambling,
			PurposeOfLoan.Donation,
			PurposeOfLoan.RealEstatePurchase,
			PurposeOfLoan.PrivateInvestment,
			PurposeOfLoan.Other,
		],
	},
	{
		currency: 'SEK',
		country: 'se',
		income: [200000, 450000, 700000, 1000000, 1000001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [10000, 50000, 200000, 450000, 450001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [10000, 50000, 200000, 450000, 450001],
		occupation: [
			OccupationType.PartTime,
			OccupationType.Entrepreneur,
			OccupationType.Unemployed,
			OccupationType.Pensioner,
			OccupationType.SickLeave,
			OccupationType.Student,
			OccupationType.EmployedByHours,
			OccupationType.Permanent,
			OccupationType.Other,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.PersonalEconomicSpace,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.Retirement,
			PurposeOfDeposit.Other,
		],
		moneySource: [
			MoneySource.OtherBusiness,
			MoneySource.OtherSavings,
			MoneySource.Inheritance,
			MoneySource.InsuranceReimbursement,
			MoneySource.SalesOfProperty,
			MoneySource.SalesOfVehicle,
			MoneySource.SaleOfCompany,
			MoneySource.Gift,
			MoneySource.CapitalGains,
			MoneySource.Income,
			MoneySource.Investments,
			MoneySource.Gambling,
			MoneySource.Other,
		],
	},
	{
		currency: 'NOK',
		country: 'no',
		income: [200000, 450000, 700000, 1000000, 1000001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [200000, 500000, 1000000, 2000000],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [10000, 50000, 200000, 450000, 450001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Housewife,
			OccupationType.Entrepreneur,
			OccupationType.Retired,
			OccupationType.Student,
			OccupationType.SickLeave,
		],
		moneySource: [
			MoneySource.Income,
			MoneySource.Investments,
			MoneySource.Inheritance,
			MoneySource.Gift,
			MoneySource.SalesOfProperty,
			MoneySource.SaleOfCompany,
			MoneySource.Gambling,
			MoneySource.OtherBusiness,
			MoneySource.CapitalGains,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.PersonalEconomicSpace,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.Retirement,
		],
	},
	{
		currency: '€',
		country: 'es',
		income: [20000, 45000, 70000, 100000, 100001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Farmer,
			OccupationType.Housewife,
			OccupationType.Entrepreneur,
			OccupationType.SickLeave,
			OccupationType.Unemployed,
			OccupationType.Student,
			OccupationType.PublicServant,
			OccupationType.Retired,
			OccupationType.Pensioner,
			OccupationType.FixedTerm,
			OccupationType.PartTime,
			OccupationType.Other,
		],
		education: [
			Education.ProfessEducation,
			Education.Basic,
			Education.HighSchool,
			Education.University,
			Education.Other,
		],
		employmentSector: [
			EmploymentSector.Administration,
			EmploymentSector.Agriculture,
			EmploymentSector.Art,
			EmploymentSector.Finance,
			EmploymentSector.ConstructionRealEstate,
			EmploymentSector.Culture,
			EmploymentSector.EducationScience,
			EmploymentSector.PublicSector,
			EmploymentSector.IndustryEnergy,
			EmploymentSector.Gambling,
			EmploymentSector.LegalOrJudicial,
			EmploymentSector.Business,
			EmploymentSector.Technician,
			EmploymentSector.Health,
			EmploymentSector.Security,
			EmploymentSector.Services,
			EmploymentSector.Technology,
			EmploymentSector.Transport,
			EmploymentSector.Tourism,
			EmploymentSector.StallHolder,
			EmploymentSector.Other,
		],
		maritalStatus: [
			MaritalStatus.Married,
			MaritalStatus.Divorced,
			MaritalStatus.Cohabitee,
			MaritalStatus.Single,
			MaritalStatus.Widow,
		],
		accommodationType: [
			AccommodationType.Renter,
			AccommodationType.Tenant,
			AccommodationType.WithParents,
			AccommodationType.Owner,
			AccommodationType.Other,
		],
	},
	{
		//should be investigated for values
		currency: 'EUR',
		country: 'ee',
		income: [700, 1800, 2999, 3000],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.FixedTerm,
			OccupationType.Entrepreneur,
			OccupationType.Other,
		],
	},
	{
		currency: '€',
		country: 'de',
		income: [20000, 45000, 70000, 100000, 100001],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Student,
			OccupationType.TemporarilyEmployed,
			OccupationType.Housewife,
			OccupationType.Unemployed,
		],
		moneySource: [
			MoneySource.Income,
			MoneySource.Inheritance,
			MoneySource.SalesOfProperty,
			MoneySource.Donation,
			MoneySource.SaleOfCompany,
			MoneySource.Gambling,
			MoneySource.OtherBusiness,
			MoneySource.CapitalGains,
		],
		purposeOfDeposit: [
			PurposeOfDeposit.Renovation,
			PurposeOfDeposit.NextInKin,
			PurposeOfDeposit.SavingForProperty,
			PurposeOfDeposit.PersonalEconomicSpace,
			PurposeOfDeposit.PrivateConsumption,
			PurposeOfDeposit.Investment,
			PurposeOfDeposit.Retirement,
		],
		purposeOfLoan: [
			PurposeOfLoan.Consumption,
			PurposeOfLoan.DebtConsolidation,
			PurposeOfLoan.Renovation,
			PurposeOfLoan.HomeExpenses,
			PurposeOfLoan.Healthcare,
			PurposeOfLoan.Travel,
			PurposeOfLoan.PurchaseVehicle,
			PurposeOfLoan.Gambling,
			PurposeOfLoan.Donation,
			PurposeOfLoan.RealEstatePurchase,
			PurposeOfLoan.PrivateInvestment,
		],
	},
	{
		//should be investigated for values
		currency: 'EUR',
		country: 'lt',
		income: [700, 1200, 1800, 2500, 2501],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.FixedTerm,
			OccupationType.Entrepreneur,
			OccupationType.Other,
		],
	},
	{
		//should be investigated for values
		currency: 'EUR',
		country: 'lv',
		income: [700, 1200, 1800, 2500, 2501],
		expectedDeposits: [5, 12, 24, 25],
		expectedDepositsAmount: [1000, 5000, 20000, 45000, 45001],
		expectedWithdrawals: [5, 12, 24, 25],
		expectedWithdrawalsAmount: [1000, 5000, 20000, 45000, 45001],
		occupation: [
			OccupationType.Permanent,
			OccupationType.Pensioner,
			OccupationType.Unemployed,
			OccupationType.FixedTerm,
			OccupationType.Entrepreneur,
			OccupationType.Other,
		],
	},
]
export interface IKycCurrencyAndValues {
	currency: string
	country: string
	income: number[]
	expectedDeposits: number[]
	expectedDepositsAmount: number[]
	expectedWithdrawals: number[]
	expectedWithdrawalsAmount: number[]
	occupation?: OccupationType[]
	purposeOfDeposit?: PurposeOfDeposit[]
	purposeOfLoan?: PurposeOfLoan[]
	moneySource?: MoneySource[]
	depositOwner?: DepositOwner[]
	maritalStatus?: MaritalStatus[]
	accommodationType?: AccommodationType[]
	education?: Education[]
	employmentSector?: EmploymentSector[]
}